import React from "react";

const PasswordContext = React.createContext({
  password: "",
  setPassword: () => {},
});

export default PasswordContext;
